import { render, staticRenderFns } from "./ProfileView.vue?vue&type=template&id=2a87167f"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"
import style0 from "./ProfileView.vue?vue&type=style&index=0&id=2a87167f&prod&lang=css"
import style1 from "./ProfileView.vue?vue&type=style&index=1&id=2a87167f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports